import Constants from 'utils/constants';
import { NullableStudy } from '@contexts/local-state-context';
import { IUser } from '@contexts/user-context';
import Modules from '@config/modules';

export const isStudyMember = (moduleValue: number, study: NullableStudy, user: IUser) => {
    const validModules = [
        Modules.CentralMonitoring.value,
        Modules.CentralMonitoring2.value,
        Modules.RiskAssessment.value,
        Modules.SubjectMonitoring.value,
    ];

    if (!validModules.includes(moduleValue) || user.isSystemAdmin(Constants.SystemAdminLevel.Reviewer)) {
        return true;
    }

    const isSubjectMonitoring = moduleValue === Modules.SubjectMonitoring.value;

    const members = isSubjectMonitoring ? study?.smMembers : study?.members;

    return members?.some((m) => m?.userId === user.id && m?.active);
};
